import { UserProfile } from '../entities/user';
import { UserDTO } from '../dtos/user.dto';

export class UserMapper {
  static toDTO(user: UserProfile): UserDTO {
    return {
      id: user.id,
      email: user.email,
      fullName: user.full_name,
      avatarUrl: user.avatar_url,
      currentProjectId: user.current_project_id,
      language: user.language,
      createdAt: user.created_at,
      updatedAt: user.updated_at
    };
  }
}